import React from 'react';

import { Box, HStack, Stack, Text } from '@chakra-ui/react';

import { useKnowledgeBase } from 'components/DataDisplay/KnowledgeBase/hook/useKnowledgeBase';
import { RightArrowIcon } from 'components/Icons';
import { LearnMoreFieldType } from 'containers/SharedState/types';

export interface KnowledgeBaseLink {
  label: string;
  field: LearnMoreFieldType;
}

interface Props {
  links: KnowledgeBaseLink[];
}

export const KnowledgeBaseLinks = (props: Props) => {
  const { links } = props;
  const { setLearnMore } = useKnowledgeBase();
  return (
    <Stack spacing={3}>
      <Text fontWeight={600}>Learn More</Text>
      <Stack spacing={5}>
        {links.map(o => (
          <HStack
            key={o.field}
            onClick={() => setLearnMore(o.field)}
            cursor="pointer"
            color="primary"
          >
            <Box boxSize={4}>
              <RightArrowIcon />
            </Box>
            <Box>{o.label}</Box>
          </HStack>
        ))}
      </Stack>
    </Stack>
  );
};
